import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { parseISO } from 'date-fns'
import React from 'react'
import { IBanner } from 'shared/interfaces/banner'
import HandleIconSvg from '../../../assets/images/handle.svg'

interface ISortableItemProps {
	id: string
	banner: IBanner
	index: number
}

export function SortableItem(props: ISortableItemProps) {
	const { attributes, listeners, setNodeRef, transform, transition } =
		useSortable({ id: props.id })

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	}

	return (
		<div ref={setNodeRef} style={style} className='banner-order-row'>
			<div className='position-column'>{props.index + 1}</div>
			<div className='image-wrapper'>
				<img
					src={props.banner.image as string}
					alt={props.banner.title as string}
				/>
			</div>
			<div className='title-column'>{props.banner.title}</div>
			<div className='register-column'>
				{parseISO(props.banner.updatedAt).toLocaleDateString('pt-BR')}
			</div>
			<div {...attributes} {...listeners} className='drag-handle'>
				<img src={HandleIconSvg} alt='Handle' width={12} height={12} />
			</div>
		</div>
	)
}
